
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Fiftyseaterbusinpimpri() {



    const cardData =
    {
        keyword: '50 Seater Bus On Rent in Pimpri Chinchwad',
        heading: 'Amruta Travels: 50 Seater Bus On Rent in Pimpri Chinchwad',
        headingDescription: 'Amruta Travels offers 50 Seater Bus on Rent in Pimpri Chinchwad, the ideal choice for transporting large groups with ease and comfort. Whether it is a corporate event, school excursion, wedding function, or outstation trip, our spacious and well-maintained 50-seater buses provide a reliable and stress-free travel experience. With comfortable seating, air-conditioned interiors, experienced drivers, and timely service, Amruta Travels ensures every journey is safe, smooth, and enjoyable.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',


  "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Located around 120 km from Pune, Mahabaleshwar is a picturesque hill station in the Western Ghats, known for its cool climate, evergreen forests, and stunning viewpoints such as Arthur’s Seat, Wilson Point (the highest point), and Kate's Point. The region is famous for its strawberry farms, especially during the Strawberry Festival held in spring. Other attractions include Venna Lake for boating, Mapro Garden for strawberry-based treats, and ancient temples like Panchganga and Mahabaleshwar Temple. It's a popular destination for families, honeymooners, and nature enthusiasts seeking a refreshing escape from city life."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range offer a perfect blend of natural beauty and adventure. Lonavala is known for its misty mountains, lush greenery, and monsoon waterfalls like Kune and Bhivpuri. Attractions include Bhushi Dam, Tiger’s Leap, Rajmachi Fort, and Karla & Bhaja Caves. Khandala is equally famous for its panoramic valley views and trekking routes. The area is ideal for a weekend drive, with scenic routes and roadside chikki stalls that add to the charm of this quick getaway."
    },
    {
      "title": "Shirdi",
      "description": "About 190 km from Pune, Shirdi is a sacred town revered by followers of Sai Baba. The Sai Baba Samadhi Mandir is the main attraction, drawing millions of devotees every year. Pilgrims can also visit Dwarkamai, Chavadi, and the Sai Heritage Village. The spiritual ambiance, combined with well-maintained infrastructure and religious events, makes Shirdi a prominent destination for those seeking peace, healing, and spiritual growth."
    },
    {
      "title": "Goa",
      "description": "Located nearly 450 km from Pune, Goa is India’s premier beach destination, known for its lively culture, golden beaches, and Portuguese heritage. From North Goa’s party hotspots like Baga, Anjuna, and Calangute to South Goa’s serene stretches like Palolem and Colva, there’s a vibe for every traveler. Apart from beaches, visitors can explore Aguada Fort, Basilica of Bom Jesus, spice plantations, vibrant flea markets, and indulge in thrilling water sports. Goa is also a haven for foodies, offering authentic seafood, Goan curries, and beachside shacks serving refreshing cocktails."
    },
    {
      "title": "Nashik",
      "description": "Around 210 km from Pune, Nashik is a city of immense cultural, historical, and spiritual significance. It is one of the four cities where the Kumbh Mela is held. Attractions include the ancient Kalaram Temple, Muktidham Temple, Pandavleni Caves, and Trimbakeshwar Temple—an important Jyotirlinga. Nashik is also the wine capital of India, home to Sula Vineyards, York Winery, and many tasting tours. The Godavari River adds to its charm, making it a harmonious blend of spirituality and leisure tourism."
    },
    {
      "title": "Alibaug",
      "description": "Situated about 140 km from Pune, Alibaug is a tranquil coastal town offering a perfect mix of beaches, history, and nature. Popular beaches include Nagaon, Alibaug Beach, and Kashid Beach, all great for swimming, sunbathing, and water sports. The iconic Kolaba Fort, accessible during low tide, adds historical value to the destination. You can also explore Korlai Fort, Kanakeshwar Temple, and local seafood cuisine. Ideal for weekend trips, Alibaug also offers ferry services from Mumbai for added convenience."
    },
    {
      "title": "Kolhapur",
      "description": "Roughly 235 km from Pune, Kolhapur is a vibrant city known for its divine Mahalaxmi Temple, which draws pilgrims throughout the year. The city is equally famous for its spicy cuisine, Kolhapuri chappals, and traditional arts. Attractions include Rankala Lake for evening strolls, Panhala Fort offering panoramic views, and the New Palace Museum showcasing royal heritage. With its rich cultural identity and warm hospitality, Kolhapur is ideal for heritage and culinary tourism."
    },
    {
      "title": "Lavasa",
      "description": "Just 60 km from Pune, Lavasa is an Italian-inspired planned city nestled in the Sahyadri hills. It features beautiful waterfronts, European-style architecture, and a peaceful atmosphere perfect for a quick weekend escape. Activities include kayaking, zip-lining, and lakeside cycling. With cozy resorts, conference centers, and nature trails, Lavasa attracts both families and corporate travelers. The weather remains pleasant most of the year, enhancing its appeal as a rejuvenating destination close to Pune."
    },
    {
      "title": "Satara & Kaas Plateau",
      "description": "About 120 km from Pune, Satara serves as the base for exploring the Kaas Plateau—popularly known as the 'Valley of Flowers' of Maharashtra. The plateau, a UNESCO World Natural Heritage site, bursts into a riot of colors with over 850 species of wildflowers during the monsoon season. Satara is also known for Ajinkyatara Fort, Thoseghar Waterfalls, and Sajjangad Fort. The natural beauty and biodiversity make this region a paradise for trekkers, botanists, and photographers."
    },
    {
      "title": "Aurangabad",
      "description": "Situated 235 km from Pune, Aurangabad is a historical treasure trove, offering insights into ancient art, architecture, and culture. The city is home to the world-famous Ajanta and Ellora Caves, adorned with exquisite carvings and paintings dating back to 2nd century BCE. Other attractions include Bibi Ka Maqbara (a replica of the Taj Mahal), Daulatabad Fort, and Aurangabad Caves. The city is also a gateway to Grishneshwar Jyotirlinga and Paithani saree shopping, making it a must-visit for heritage lovers."
    }
  ],

   "services": [
    {
      "name": "50 Seater Bus Pimpri Chinchwad Rent",
      "description": "Rent a 50 Seater bus in Pimpri Chinchwad for large group trips. Perfect for corporate events, weddings, or family tours, our buses are equipped with air conditioning, comfortable seating, and modern amenities to ensure a pleasant journey."
    },
    {
      "name": "AC 50 Seater Bus Hire PCMC",
      "description": "Hire an AC 50 Seater bus in PCMC for a luxurious travel experience. Our buses are designed to offer maximum comfort and convenience for long-distance travel, including corporate trips, school outings, or family tours."
    },
    {
      "name": "Corporate 50 Seater Bus in Pimpri",
      "description": "Looking for transport for your corporate team? Hire our 50 Seater buses in Pimpri for seamless and comfortable office trips, team-building exercises, or corporate events. Our buses are equipped with modern amenities for a stress-free ride."
    },
    {
      "name": "Wedding Bus Rental 50 Seater Pimpri",
      "description": "Make your wedding transportation smooth and stylish with our 50 Seater buses. Perfect for transporting wedding guests to and from the venue, ensuring everyone arrives in comfort and style."
    },
    {
      "name": "School Picnic 50 Seater Bus PCMC",
      "description": "Ensure the comfort and safety of students during school picnics with our 50 Seater buses. Equipped with comfortable seating and air conditioning, our buses are ideal for educational tours, picnics, and field trips."
    },
    {
      "name": "Outstation Bus 50 Seater from PCMC",
      "description": "Travel to outstation destinations in luxury with our 50 Seater buses. Whether it’s for a religious tour, family vacation, or corporate trip, our buses offer ample space, comfortable seating, and air conditioning for a relaxing experience."
    },
    {
      "name": "Affordable 50 Seater Bus Hire Pimpri Chinchwad",
      "description": "Get affordable 50 Seater bus rental options in Pimpri Chinchwad for your group trips. Enjoy a luxury travel experience without breaking the bank, ideal for large groups, corporate events, and family outings."
    },
    {
      "name": "Pimpri to Shirdi 50 Seater Bus Hire",
      "description": "Take a spiritual journey to Shirdi in our 50 Seater buses. With comfortable seating, air conditioning, and a professional driver, we ensure a safe and pleasant pilgrimage experience."
    },
    {
      "name": "Pimpri to Mahabaleshwar 50 Seater Bus Rental",
      "description": "Explore the beautiful hill station of Mahabaleshwar in comfort with our 50 Seater buses. Equipped with air conditioning and spacious seating, this is the perfect travel option for group tours."
    },
    {
      "name": "50 Seater Event Bus Booking PCMC",
      "description": "Book a 50 Seater bus for your next event in PCMC. Ideal for conferences, weddings, corporate events, or large group gatherings, our buses offer luxury, comfort, and efficiency."
    },
    {
      "name": "50 Seater Bus Hire in Bhosari",
      "description": "For large group travel, hire a 50 Seater bus in Bhosari. Whether it's a corporate function, wedding, or family trip, our buses ensure your group travels in comfort and style."
    },
    {
      "name": "Full Bus Booking PCMC 50 Seater",
      "description": "Full 50 Seater bus booking available in PCMC for group tours, corporate events, and family trips. Ensure a comfortable and enjoyable journey with our premium buses, equipped with all modern amenities."
    },
    {
      "name": "AC Coach Hire 50 Seater Pimpri",
      "description": "Our 50 Seater AC coaches are available for hire in Pimpri. Perfect for long-distance travel, these buses offer air conditioning, comfortable seating, and modern amenities for an enjoyable journey."
    },
    {
      "name": "Bharat Benz 50 Seater Bus in PCMC",
      "description": "Rent a luxurious Bharat Benz 50 Seater bus in PCMC for an exceptional travel experience. Equipped with top-notch amenities, this bus is perfect for weddings, corporate events, and large group travel."
    },
    {
      "name": "Comfortable Bus Hire 50 Seater Pimpri Chinchwad",
      "description": "Looking for a comfortable ride for your group? Our 50 Seater buses in Pimpri Chinchwad offer a relaxed and enjoyable travel experience, equipped with air conditioning, plush seating, and all necessary amenities."
    }
  ],
  "tableData": [
    ["50 Seater Bus Pimpri Chinchwad Rent", "AC 50 Seater Bus Hire PCMC"],
    ["Corporate 50 Seater Bus in Pimpri", "Wedding Bus Rental 50 Seater Pimpri"],
    ["School Picnic 50 Seater Bus PCMC", "Outstation Bus 50 Seater from PCMC"],
    ["Affordable 50 Seater Bus Hire Pimpri Chinchwad", "Pimpri to Shirdi 50 Seater Bus Hire"],
    ["Pimpri to Mahabaleshwar 50 Seater Bus Rental", "50 Seater Event Bus Booking PCMC"],
    ["50 Seater Bus Hire in Bhosari", "Full Bus Booking PCMC 50 Seater"],
    ["AC Coach Hire 50 Seater Pimpri", "Bharat Benz 50 Seater Bus in PCMC"],
    ["Comfortable Bus Hire 50 Seater Pimpri Chinchwad"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "50 Seater Bus on Rent in Pimpri Chinchwad",
    "WhyChoosedescription": "Amruta Travels offers spacious and comfortable 50 Seater buses for rent in Pimpri Chinchwad, perfect for large groups. Whether you’re organizing a corporate trip, school excursion, family outing, or wedding, our buses provide reliable and affordable transportation for your group."
  },
  {
    "WhyChooseheading": "Comfortable and Air-Conditioned Travel for Large Groups",
    "WhyChoosedescription": "Our 50 Seater buses are equipped with efficient air conditioning and spacious seating, ensuring your group travels in comfort, whether you're heading on a short local trip or a longer journey. Enjoy a cool, relaxing ride with plenty of room to stretch out."
  },
  {
    "WhyChooseheading": "Ideal for Group Travel, Corporate Events, and Tours",
    "WhyChoosedescription": "The 50 Seater bus is perfect for corporate events, large family get-togethers, school trips, and group tours. With ample space for all passengers and their luggage, it ensures that your entire group travels together comfortably and efficiently."
  },
  {
    "WhyChooseheading": "Affordable Rates with Transparent Pricing",
    "WhyChoosedescription": "At Amruta Travels, we offer clear, competitive pricing for 50 Seater bus rentals in Pimpri Chinchwad. Our rates include fuel, tolls, driver allowances, taxes, and more, ensuring there are no hidden charges or surprises along the way."
  },
  {
    "WhyChooseheading": "Professional Drivers for Safe and Timely Journeys",
    "WhyChoosedescription": "Our drivers are experienced, licensed, and knowledgeable about the local and outstation routes. They ensure that your group reaches its destination safely and on time while maintaining a courteous and professional attitude throughout the journey."
  },
  {
    "WhyChooseheading": "Well-Maintained Fleet for a Smooth Ride",
    "WhyChoosedescription": "Our 50 Seater buses are regularly serviced, inspected, and cleaned to ensure a safe and smooth ride. We prioritize passenger safety and comfort, so you can relax knowing you’re traveling in a well-maintained and reliable vehicle."
  },
  {
    "WhyChooseheading": "Convenient Booking Process and 24/7 Customer Support",
    "WhyChoosedescription": "Booking your 50 Seater bus with Amruta Travels is quick and easy. You can book online, by phone, or visit our office in Pimpri Chinchwad. Our dedicated 24/7 customer support team is always available to assist you with bookings, changes to your itinerary, or any other inquiries."
  },
  {
    "WhyChooseheading": "Perfect for Pimpri Chinchwad and Outstation Travel",
    "WhyChoosedescription": "Whether you're exploring Pimpri Chinchwad’s local attractions or venturing out on a long-distance trip, our 50 Seater buses are perfect for any occasion. With ample space, comfort, and reliability, they make travel simple and hassle-free."
  }
]




















    }

const faqData = [
  {
    question: 'Can I rent a 50-seater bus in Pimpri Chinchwad with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers 50-seater buses for rent in Pimpri Chinchwad. These buses are perfect for large groups, ideal for corporate events, family trips, school tours, or long-distance travel.',
  },
  {
    question: 'What amenities are available in the 50-seater bus?',
    answer: 'Our 50-seater buses are equipped with comfortable seating, air conditioning, modern entertainment systems, ample legroom, spacious luggage compartments, and clean interiors to ensure a comfortable and enjoyable journey.',
  },
  {
    question: 'Is the 50-seater bus available for both local and outstation travel?',
    answer: 'Yes, the 50-seater bus is available for both local travel within Pimpri Chinchwad and outstation trips to popular destinations like Lonavala, Mahabaleshwar, Shirdi, Mumbai, and other tourist spots.',
  },
  {
    question: 'Is a driver included in the 50-seater bus rental?',
    answer: 'Yes, all 50-seater bus rentals from Amruta Travels come with a professional, licensed driver who ensures a safe, timely, and comfortable journey for all passengers.',
  },
  {
    question: 'How much does it cost to rent a 50-seater bus in Pimpri Chinchwad?',
    answer: 'Rental charges for the 50-seater bus depend on factors such as distance, trip duration, and services required. Typically, rates start from ₹45–₹60 per km. Please contact us with your itinerary for an accurate and customized quote.',
  },
  {
    question: 'Is the 50-seater bus comfortable for long journeys?',
    answer: 'Yes, the 50-seater bus is designed for long journeys, offering ample seating space, air conditioning, and a comfortable ride for passengers, ensuring an enjoyable trip.',
  },
  {
    question: 'Are the 50-seater buses well-maintained and sanitized?',
    answer: 'Absolutely. All our 50-seater buses are regularly maintained, thoroughly cleaned, and sanitized before each trip to ensure hygiene, safety, and passenger comfort.',
  },
  {
    question: 'How do I book a 50-seater bus in Pimpri Chinchwad?',
    answer: 'Booking a 50-seater bus is simple! You can easily book online via our website or contact our customer support team for assistance. We offer fast booking and transparent pricing.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Rahul Agrawal',
    role: 'Business Executive, Pimpri Chinchwad',
    text: 'We hired a 50-seater bus from Amruta Travels for a corporate event. The bus was comfortable, clean, and well-maintained. The driver was professional, and the journey was smooth. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Sushma Bhat',
    role: 'Family Trip Organizer',
    text: 'I booked a 50-seater bus for a family trip to Mahabaleshwar. The bus was very spacious, and the air conditioning made the journey comfortable. The service provided by Amruta Travels was exceptional!',
    rating: 5,
  },
];






























































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "50 Seater Bus On Rent in Pimpri Chinchwad",
  "image": "https://bushireinpune.com/assets/images/50-seater-bus-pimpri-chinchwad.jpg",
  "description": "Amruta Travels offers 50 Seater Bus on Rent in Pimpri Chinchwad for corporate events, school picnics, weddings, and outstation travel. Our buses are available for local and outstation trips, including routes to Shirdi, Mahabaleshwar, and more. Book comfortable and affordable 50 seater buses in Pimpri Chinchwad, Bhosari, and PCMC with experienced drivers for a hassle-free journey.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "11800"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6500",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/50-seater-bus-rent-pimpri-chinchwad"
  }
};







    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | 50 Seater Bus On Rent in Pimpri Chinchwad | Affordable Bus Hire for Weddings & Events</title>
  <meta 
    name="description" 
    content="Hire a 50 seater bus on rent in Pimpri Chinchwad for school picnics, corporate events, weddings, and outstation trips to Shirdi, Mahabaleshwar, and more. Comfortable and affordable 50 seater buses available with Amruta Travels." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/94.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Fiftyseaterbusinpimpri;